import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
const PostFeaturedImage = (props) => {
    if (!props.children) {
        return React.createElement(React.Fragment, null);
    }
    const sizeSlug = props.oneLastNews ? "xl" : "medium";
    return (React.createElement(React.Fragment, null,
        React.createElement(GatsbyImage, { className: "wp-block-post-featured-image", image: props.children.localFile.childImageSharp[sizeSlug] ||
                props.children.localFile.childImageSharp.gatsbyImageData, alt: props.children.altText || props.children.caption })));
};
PostFeaturedImage._ges_name = "PostFeaturedImage";
export default PostFeaturedImage;
